import React from 'react'
import cx from 'classnames'
import GoogleSignIn from './Button'

import { ErrorMessage, WaitMessage, WaitIcon, InfoMessage } from '../StatusMessage'
import withErrorBoundary from '../ErrorBoundary'

export default withErrorBoundary(class Login extends React.PureComponent {
  render () {
    const {
      className,
      isVerifying,
      error,
      config
    } = this.props
    return (
      <div
        className={cx('LoginForm', className, {
          isVerifying,
          hasConfig: config,
          show: config
        })}
      >
        <div
          className={cx('LoginButton', 'showable', className, {
            isVerifying,
            hasConfig: config,
            show: config
          })}
        >
          {config && (
            <GoogleSignIn
              key={config.clientID}
              config={config}
              onSuccess={this.props.onSuccess}
              onFailure={this.props.onFailure}
            />
          )}
        </div>
        <div className={cx('LoginPending', 'showable', { show: !error && (!config || isVerifying) })}>
          {!config ? <WaitIcon /> : isVerifying ? <WaitMessage title='Verifying...' /> : ''}
        </div>
        <div className={cx('LoginError', 'showable', { show: !!error })}>
          {error && <ErrorMessage subtitle='Login Failed' error={error} />}
          {error && error.error === 'idpiframe_initialization_failed' && (
            <InfoMessage title={'Try enabling 3rd-Party cookies in your browser.'} />
          )}
        </div>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/Login/Form.js